import React from 'react';

interface PageHeaderProps {
    tag?: string;
    title: string;
    titleAccent?: string;
    subtitle?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ tag, title, titleAccent, subtitle }) => {
    return (
        <section className="relative py-24 bg-white border-b border-maat-sand pt-32 overflow-hidden">
            <div className="container mx-auto px-6 relative z-10">
                <div className="max-w-4xl mx-auto text-center">
                    {tag && (
                        <span className="text-maat-gold font-semibold uppercase tracking-widest text-sm mb-4 block animate-in fade-in slide-in-from-bottom-2 duration-700">
                            {tag}
                        </span>
                    )}
                    <h1 className="text-4xl md:text-6xl font-serif text-maat-blue mb-8 leading-tight animate-in fade-in slide-in-from-bottom-4 duration-1000">
                        {title} {titleAccent && <span className="text-maat-gold italic">{titleAccent}</span>}
                    </h1>
                    {subtitle && (
                        <p className="text-xl text-maat-blue/70 leading-relaxed max-w-3xl mx-auto font-light animate-in fade-in slide-in-from-bottom-6 duration-1000">
                            {subtitle}
                        </p>
                    )}
                </div>
            </div>
            {/* Subtle decorative element similar to Services but lighter for white background */}
            <div className="absolute top-0 right-0 w-[30%] h-full bg-maat-stone/50 -skew-x-12 translate-x-1/2 pointer-events-none"></div>
        </section>
    );
};

export default PageHeader;
